function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-204 -208)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 3",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(204 208)",
  fill: "#002f4d"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon open-magnifying-glass",
  d: "M215.016 213.543a5.873 5.873 0 000 11.746 5.8 5.8 0 002.785-.688 1.678 1.678 0 00.218.218l1.678 1.678a1.711 1.711 0 102.416-2.416l-1.677-1.679a1.678 1.678 0 00-.268-.218 5.794 5.794 0 00.738-2.785 5.879 5.879 0 00-5.873-5.873zm0 1.678a4.175 4.175 0 014.195 4.195 4.208 4.208 0 01-1.108 2.886l-.05.05a1.678 1.678 0 00-.218.219 4.2 4.2 0 01-2.836 1.057 4.195 4.195 0 010-8.39z",
  fill: "#fdfdfd"
}));
var SvgFind = function SvgFind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};
export default SvgFind;